/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { matchPath } from 'react-router';


export const parse = (value, routeEnum) =>
{
  let result = null;

  for (const type of Object.values(routeEnum))
  {
    const match = matchPath(value, { path: type });

    if (match && (result == null || result.type.length < type.length))
    {
      result = { value, type, args: match.params };
    }
  }

  if (result == null)
  {
    throw new Error('Route parsing failed for: ' + value);
  }

  return new Route(result);
}


export default class Route
{
  constructor ({ value, type, args})
  {
    this.type = type;
    this.args = args;
    this.value = value;
  }


  getType ()
  {
    return this.type;
  }


  getArgs ()
  {
    return this.args;
  }


  getValue ()
  {
    return this.value;
  }


}



